import { getLocalStorageMenuItem } from "./storage";

const getTimeZone = () => {
  const timeZone = getLocalStorageMenuItem("timezone");
  return timeZone ? timeZone.replace(/["]+/g, '') : "";
};

export const getAuth = () => {
  const token = getLocalStorageMenuItem("jwt_authorization") || getLocalStorageMenuItem("authorization");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: getLocalStorageMenuItem("lang"),
      venueId: getLocalStorageMenuItem("venueId"),
      timeZone: getTimeZone(),
    },
  };
};

export const getAuthMobile = () => {
  const token = getLocalStorageMenuItem("mobileLoginToken");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: getLocalStorageMenuItem("lang"),
      timeZone: getTimeZone(),
    },
  };
};

export const getGustAuthMobile = () => {
  const token = getLocalStorageMenuItem("gustToken");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: getLocalStorageMenuItem("lang"),
      timeZone: getTimeZone(),
    },
  };
};

export const getAuthAdmin = () => {
  const token = getLocalStorageMenuItem("authorization");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: getLocalStorageMenuItem("lang"),
      venueId: getLocalStorageMenuItem("venueId"),
      timeZone: getTimeZone(),
    },
  };
};
